$(document).ready(function () {


    // var url = window.location.pathname;
    // var address = window.location.href;
    //
    //
    // if (url == '/') {
    //     $(".menu__ul > .menu__li").eq(0).addClass('active');
    // } else {
    //     $('.menu__li > .menu__link[href^="' + address + '"]').parent().addClass('active').closest('.menu__li--dropdown').addClass('active');
    //     ;
    //     $('.menu__li > .menu__link[href^="/' + window.location.pathname.split("/")[1] + '"]').parent().addClass('active').closest('.menu__li--dropdown').addClass('active');
    //     ;
    // }

    /* Select active menu */
    // var adress = window.location.pathname;
    // first = adress.split('/');
    // first = first[1];
    // if (adress == '/') {
    //     $(".menu__ul > .menu__li").eq(0).addClass('active');
    // } else {
    //     $(".menu__ul > .menu__li").each(function (index) {
    //         if ($(this).html().indexOf(adress) > 0) {
    //             $(".menu__ul > .menu__li.active").removeClass('active');
    //             $(this).addClass('active');
    //             if ($(this).hasClass('menu__li-dropdown')) {
    //
    //                 $(this).find('ul li').each(function (index) {
    //                     if ($(this).html().indexOf(adress) > 0) {
    //                         $(this).addClass('active');
    //                     }
    //                 });
    //             }
    //             first = null;
    //             return;
    //         }
    //         else if ($(this).html().indexOf(first) > 0) {
    //             $(this).addClass('active');
    //         }
    //
    //         $('.menu__li.active').closest('.menu__li-dropdown').addClass('active');
    //     });
    // }
    // /* next level menu */
    // $('.dropdown-submenu a.test').on("click", function (e) {
    //     $(this).next('ul').toggle();
    //     e.stopPropagation();
    //     e.preventDefault();
    // });


    $('.scrollTop').on('click', function (e) {
        e.preventDefault();
        $("html, body").animate({scrollTop: 0}, "slow");

    });


    var preloader = $('#preloader');

    $(window).load(function () {
        preloader.addClass('preloader-hiding');

        preloader.bind('transitionend', function () {
            preloader.addClass('preloader-hidden');
            preloader.removeClass('preloader-hiding');
        });

    });


//# sourceMappingURL=default.js.map

// script orphan letters

    $('.text ,p ,h1 ,h2 ,h3 ,h4 ,h5 ').each(function () {
        var tekst = $(this).html();
        tekst = tekst.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;"); //jednoznakowe
        tekst = tekst.replace(/(\s)([^<][\S]{1})[\s]+/g, "$1$2&nbsp;"); //dwuznakowe
        $(this).html(tekst);
    });


    $(document).ready(function () {
        $('.components__expandableHeader').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).find('.components__expandableButton').removeClass('active');
                $(this).parent().find('.components__expandableContent').slideUp();
            } else {
                $('.components__expandableHeader').removeClass('active');
                $('.components__expandableButton').removeClass('active');
                $('.components__expandableContent').slideUp();
                $(this).addClass('active');
                $(this).find('.components__expandableButton').addClass('active');
                $(this).parent().find('.components__expandableContent').slideDown();
            }
        });
    });


    $('.iframeOnlyMovie').each(function () {
        var url = $(this).data('url');
        var string = (url.slice(url.lastIndexOf("/")));
        var movie = string.replace("/watch?v=", "https://www.youtube.com/embed/");
        $(this).attr('src', movie);

    });


    $(window).on('scroll', function () {
        var st = $(window).scrollTop();

        if (st > 40) {
            $('.header__img').addClass('small');
            $('.menu__ul').addClass('margin');
        } else {
            $('.header__img').removeClass('small');
            $('.menu__ul').removeClass('margin');
        }


        if (st > 200) {
            $('.scrollTop').addClass('show');
        } else {
            $('.scrollTop').removeClass('show');
        }

    });

    if ($("a[rel^=lightbox]").length > 0) {

        var lightboxGallery = $("a[rel^=lightbox]").simpleLightbox({
            captionSelector: 'self'
        });
    }

    // $("*[data-animate]").each(function () {
    //     $(this).viewportChecker({
    //         classToAdd: "animated " + $(this).data("animate") + " slow",
    //         classToRemove: "hiddenElement",
    //         offset: "0%"
    //     });
    // });

    $('.accordion__button').on('click', function (e) {
        e.preventDefault();
        var accordion = $(this).closest('.accordion__item');
        accordion.toggleClass('open');

        if (accordion.hasClass('open'))
        {
            $(this).addClass('open');
            accordion.find('.accordion__text--short').fadeOut('fast');
            setTimeout(function()
            {
                accordion.find('.accordion__text--long').slideDown('fast');
            },300);
        }else
        {
            $(this).removeClass('open');
            accordion.find('.accordion__text--long').slideUp('fast');
            setTimeout(function()
            {
                accordion.find('.accordion__text--short').fadeIn('fast');
            },300);
        }


    });


    var mainNavLinks = document.querySelectorAll(".menu a");
    var mainSections = document.querySelectorAll("section");
    var lastId;
    var cur = [];
    window.addEventListener("scroll", function (event) {
        var fromTop = window.scrollY;
        mainNavLinks.forEach(function (link) {
            var section = document.querySelector(link.hash);
            var offset = section.offsetTop - 250;

            if (offset <= fromTop && offset + section.offsetHeight > fromTop) {
                link.classList.add("active");
            } else {
                link.classList.remove("active");
            }
        });
    });


    $('.menuButton').on('click', function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $('.menu').slideToggle();

    });

    if (screen.width <= 1024)
    {
        $('.menu__ul  a').on('click', function()
        {
           $('.menuButton').removeClass('active');
           $('.menu').slideUp();
        });
    }

});
//# sourceMappingURL=default.js.map
